import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { BxVerticalNavigationComponent } from '@core/components/navigation/vertical/vertical.component';
import { BxNavigationService } from '@core/components/navigation/navigation.service';
import { CBNavigationItem } from '@core/components/navigation/navigation.types';

@Component({
    selector       : 'cb-vertical-navigation-spacer-item',
    templateUrl    : './spacer.component.html',
    styles         : [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BxVerticalNavigationSpacerItemComponent implements OnInit, OnDestroy
{
    @Input() item: CBNavigationItem;
    @Input() name: string;

    private _bxVerticalNavigationComponent: BxVerticalNavigationComponent;
    private _unsubscribeSpcerr: Subject<void> = new Subject();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _bxNavigationService: BxNavigationService
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Get the parent navigation component
        this._bxVerticalNavigationComponent = this._bxNavigationService.getComponent(this.name);

        // Subscribe to onRefreshed on the navigation component
        this._bxVerticalNavigationComponent.onRefreshed.pipe(
            takeUntil(this._unsubscribeSpcerr)
        ).subscribe(() => {

            // Mark for check
            this._changeDetectorRef.markForCheck();
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeSpcerr.next();
        this._unsubscribeSpcerr.complete();
    }
}
